import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useAppModal from 'hooks/useAppModal';
import ScheduledMessagesEditModal from './ScheduledMessagesEditModal';
import { SCHEDULED_MESSAGE_EDIT_MODAL_ID } from './ScheduledMessagesEditModal.constants';

const useScheduledMessagesEditModal = () => {
  const { openModal } = useAppModal();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const navigateBack = useCallback(() => {
    navigate('..', { replace: true, relative: 'path' });
  }, [navigate]);

  const openEditScheduledMessagesModal = ({
    scheduledMessageUid,
  }: {
    scheduledMessageUid: string;
  }) => {
    openModal({
      customContent: (
        <ScheduledMessagesEditModal
          scheduledMessageUid={scheduledMessageUid}
          closeModal={navigateBack}
        />
      ),
      id: SCHEDULED_MESSAGE_EDIT_MODAL_ID,
      title: t('pageAutomations.scheduledMessages.modal.title'),
      closeOnHide: false,
      onHide: navigateBack,
    });
  };

  return {
    openEditScheduledMessagesModal,
  };
};

export default useScheduledMessagesEditModal;
